import {Injectable} from '@angular/core';

/**
 * Tracks which sensitive fields in the runtime form carry a *masked* stored value — used only by the revision
 * editor. Such fields render as a read-only masked display with an explicit "edit" affordance (see
 * {@link FieldRendererComponent}): the employee sees the mask, not an input prefilled with it, so an untouched
 * value is kept (never accidentally overwritten) and editing is a deliberate action.
 *
 * Provided by the editing screen ({@link EmployeeSubmissionEditComponent}); the field-renderer injects it
 * **optionally**, so in every other context (new submission, builder preview) it is absent and fields render
 * as normal inputs.
 */
@Injectable()
export class MaskedFieldsState {
  private keys = new Set<string>();

  /** Replace the set of masked field keys (by leaf field key, matching the submission's flat storage). */
  set(keys: Iterable<string>): void {
    this.keys = new Set(keys);
  }

  /** True when a field's stored value is masked and should be edit-gated. */
  isMasked(key: string): boolean {
    return this.keys.has(key);
  }
}
